var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-author-module"},[_c('div',{staticClass:"article-author-module__swiper-wrapper"},[_c('ArticleAuthor',{attrs:{"cards":_vm.p.ArticleAuthors,"isCardLandscape":_vm.p.IsCardLandscape,"id":_vm.p.Id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }